import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'

import { type Memberships } from './collections/memberships'
import { type Teams } from './collections/teams'
import { peopleLedByEmployee } from './peopleLedByEmployee'

export const isEmployeeLedByCurrent = (
  teams: Teams,
  memberships: Memberships,
  currentEmployeeId: number,
  employee: Employee,
  contractVersions: ContractVersions
) => {
  return peopleLedByEmployee(teams, memberships, currentEmployeeId, contractVersions).includes(
    employee
  )
}
